import React from "react";
import { Link, useParams } from "react-router-dom";
import { posts, plans } from "./caseStudyData";

export default function CaseStudyPost() {
  const { slug } = useParams();
  const index = posts.findIndex((item) => item.slug === slug);

  if (index === -1) {
    return (
      <main className="blog-page page-shell post-missing">
        <h1>Case study not found</h1>
        <p><Link className="text-link" to="/case-studies">Back to all case studies</Link></p>
      </main>
    );
  }

  const post = posts[index];
  const others = posts.filter((item) => item.slug !== slug);
  const { fit } = post;

  return (
    <main className="blog-page">
      <article className="post page-shell">
        <Link className="text-link post-back" to="/case-studies">All case studies</Link>
        <p className="blog-meta"><strong>{post.segment}</strong> · {post.date} · {post.readTime}</p>
        <h1>{post.title}</h1>
        <p className="post-dek">{post.dek}</p>
        <figure className="post-figure">
          <img src={post.image} alt={post.imageAlt} />
          <figcaption>{post.imageCaption}</figcaption>
        </figure>

        <div className="post-body">
          <h2>The business</h2>
          <p>{post.business}</p>

          <h2>How it works</h2>
          <ol className="post-steps">
            {post.steps.map(([title, detail], i) => (
              <li key={title}><span>0{i + 1}</span><div><strong>{title}</strong><p>{detail}</p></div></li>
            ))}
          </ol>

          <h2>What it could cost, and what it takes to pay back</h2>
          <p>Every segment uses the same three plans. Here is the fit for this one: <strong>{fit.plan}</strong>. {fit.why}</p>
          <div className="post-plans">
            {plans.map((plan) => (
              <div className={plan.name === fit.plan ? "post-plan is-fit" : "post-plan"} key={plan.name}>
                <span>{plan.name}</span>
                <strong>${plan.price}<small> / month</small></strong>
                <p>About <b>{fit.payback[plan.name]}</b> {fit.unit}</p>
              </div>
            ))}
          </div>
          <p className="caveat post-caveat">Payback is the monthly price divided by {fit.benchmark}. Illustrative, not a Nori result.</p>

          <h2>Not yet proven</h2>
          <p>{post.caveat}</p>
        </div>

        <div className="post-cta">
          <Link className="button button-primary" to="/contact">Start a pilot <span aria-hidden="true">↗</span></Link>
          <span>Also read: {others.map((item, i) => (<React.Fragment key={item.slug}>{i > 0 && " · "}<Link className="text-link" to={`/case-studies/${item.slug}`}>{item.segment}</Link></React.Fragment>))}</span>
        </div>
      </article>
    </main>
  );
}
